import {createAsyncThunk} from "@reduxjs/toolkit";
import apiInstanceV2 from "../../Apis/AxiosV2";
import {USER_SPECIAL_PERMISSION_SERVICE} from "../EndPoints";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */

export const CreateMultipleSpecialPermission = createAsyncThunk(
    'userSpecialPermissionService/createMultipleSpecialPermission',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${USER_SPECIAL_PERMISSION_SERVICE.createMultipleSpecialPermission}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetSpecialPermissionAssigned = createAsyncThunk(
    'userSpecialPermissionService/getSpecialPermissionAssigned',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${USER_SPECIAL_PERMISSION_SERVICE.getSpecialPermissionAssigned}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetSpecialPermissionNotAssigned = createAsyncThunk(
    'userSpecialPermissionService/getSpecialPermissionNotAssigned',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${USER_SPECIAL_PERMISSION_SERVICE.getSpecialPermissionNotAssigned}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const CountSpecialPermissionAssigned = createAsyncThunk(
    'userSpecialPermissionService/countSpecialPermissionAssigned',
    async (body) => {
        const result = await apiInstanceV2
            .get(`${USER_SPECIAL_PERMISSION_SERVICE.countSpecialPermissionAssigned}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
